import type { ComponentProps, ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'

interface SettingsBannerProps extends ComponentProps<'div'> {
  title: string
  description?: ReactNode
  learnMoreUrl?: string
}

function SettingsBanner({ title, description, learnMoreUrl, children, className, ...props }: SettingsBannerProps) {
  return (
    <div data-slot="settings-banner" className={twMerge('flex w-full items-start gap-4', className)} {...props}>
      <div className="flex min-w-0 flex-1 flex-col gap-1">
        <h1 className="text-foreground type-h3 m-0 break-words">{title}</h1>
        {(description || learnMoreUrl) && (
          <div className="text-foreground-secondary type-prose-sm flex flex-col gap-1.5 text-pretty">
            {description}
            {learnMoreUrl && (
              <a href={learnMoreUrl} className="w-fit">
                Learn more →
              </a>
            )}
          </div>
        )}
      </div>
      {children && <div className="flex shrink-0 flex-row justify-end gap-2">{children}</div>}
    </div>
  )
}

export { SettingsBanner }
